import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { RegionService } from "../services/region.service";

export const regionInterceptor: HttpInterceptorFn = (req, next) => {
  const regionService = inject(RegionService);

  const region = regionService.getRegion() || "kwt_kuwait";
  const token = localStorage.getItem("jwt");

  const cloned = req.clone({
    setHeaders: {
      Authorization: `JWT ${token}`,
      "X-Region": region,
    },
  });

  console.log("🔥 Region:", region);
  console.log("🔥 Request URL:", req.url);
  console.log(
    "🔥 Headers:",
    cloned.headers.keys().map((key) => ({
      key,
      value: cloned.headers.get(key),
    })),
  );

  return next(cloned);
};
